// Teams page routes more than one module needs. The Teams page links to a
// partner team's game stats sheet, the sheet links back to that team, and
// the Admin Mode shell runs the sheet full bleed, so the paths live here once.

// The Teams page (Admin Mode > Teams).
export const TEAMS_PATH = '/admin/team-management';

// The Teams page with one team open: the page reads ?team=<team_id> when it
// loads and keeps it in the address while that team is open.
export const teamPath = (teamId) => (teamId ? `${TEAMS_PATH}?team=${encodeURIComponent(teamId)}` : TEAMS_PATH);

// A partner team's game stats sheet.
export const teamGamesPath = (teamId) => `${TEAMS_PATH}/${encodeURIComponent(teamId)}/games`;

// True on a game stats sheet, or a page under it.
export const isTeamGamesPath = (pathname = '') => /^\/admin\/team-management\/[^/]+\/games(?:\/|$)/.test(pathname);
